import cn from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import iClose from '../../../assets/images/close.svg';
import iMetamask from '../../../assets/images/metamask.svg';
import {ellipseAddress} from '../../../lib/utilities';
import {disconnect, selectWallet} from '../../../redux/wallet.slice';
import Button from '../button/button';
import './wallet.sass';

type TProps = {
  className?: string;
};

function Wallet({className}: TProps) {
  const dispatch = useDispatch();
  const wallet = useSelector(selectWallet);
  return (
    <div className={cn('wallet', className)}>
      <div className="wallet__inner">
        {wallet.address ? (
          <>
            <Button className="_blank _wallet" onClick={async () => dispatch(disconnect())}>
              <img src={iMetamask} alt="metamask" />
              {ellipseAddress(wallet.address)}
              <img src={iClose} alt="close" />
            </Button>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default Wallet;
